<template>
  <div class="location-search-filters__facet--content">
    <span>{{ value }}</span>
    <button
      class="location-search-filters__facet--remove"
      v-on:click="removeFacet" :aria-label="'Remove ' + value + ' filter'"></button>
  </div>
</template>

<script>
  export default {
    name: "Facet",
    props: {
      name: {
        type: String,
        required: true
      },
      value: {
        type: String,
        required: false
      },
      callback: {
        required: true,
        type: Function
      }
    },
    methods: {
      removeFacet() {
        // call the passed callback method to remove the facet
        this.callback(this.name, this.value);
      }
    },
    data() {
      return {}
    },
    created() {}
  }
</script>
